/* tslint:disable */
/* eslint-disable */
/**
 * Pyrra
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryRange
 */
export interface QueryRange {
    /**
     * 
     * @type {string}
     * @memberof QueryRange
     */
    query: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof QueryRange
     */
    labels: Array<string>;
    /**
     * 
     * @type {Array<Array<number>>}
     * @memberof QueryRange
     */
    values: Array<Array<number>>;
}

export function QueryRangeFromJSON(json: any): QueryRange {
    return QueryRangeFromJSONTyped(json, false);
}

export function QueryRangeFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryRange {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'query': json['query'],
        'labels': json['labels'],
        'values': json['values'],
    };
}

export function QueryRangeToJSON(value?: QueryRange | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'query': value.query,
        'labels': value.labels,
        'values': value.values,
    };
}

